/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigBurnInRefreshTime_ConfigFragmentDoc } from './ConfigBurnInRefreshTime.graphql';
export type ConfigBurnInRefreshSection_ConfigFragment = { __typename: 'ConfigurationModel', id: string, burnInRefresh?: { __typename: 'ConfigBurnInRefreshState', reported: { __typename: 'ConfigBurnInRefresh', time: string } } | null };

export const ConfigBurnInRefreshSection_ConfigFragmentDoc = gql`
    fragment ConfigBurnInRefreshSection_config on ConfigurationModel {
  id
  ...ConfigBurnInRefreshTime_config
}
    ${ConfigBurnInRefreshTime_ConfigFragmentDoc}`;